
import APIService from "./ApiService";
import {UserBehaviorTrackingService} from "./UserBehaviorTrackingService";


const ApiService = new APIService()
const userBehaviorTrackingService = new UserBehaviorTrackingService()

export {
    ApiService,
    userBehaviorTrackingService
}